/* eslint-disable camelcase */
import it_IT from './it_IT';

export default { it_IT };
